export default "__VITE_ASSET__BpX6NXkK__"